export enum TimesheetStatus {
  Draft = 1,
  Submitted = 2,
  Deleted = 899230003,
}
